import React from "react";
import "./GatewayLoader.css";

const GatewayLoader = () => (
  <div className="gw-loader" role="status" aria-live="polite">
    <div className="gw-loader__ring" aria-hidden="true" />
    <p>Loading…</p>
  </div>
);

export default GatewayLoader;
